/**
 * PDP-Aktions-Logik (Phase B + C).
 *
 *   Phase B:  Geschenkartikel werden beim Klick auf "In den Warenkorb"
 *             automatisch als zusätzliche Cart-Lines angehängt; die Shopify-
 *             Function setzt sie serverseitig auf 0 EUR.
 *
 *   Phase C:  Bonus-Choices (z.B. Bonus-Kopf, Bonus-Haar-Style) werden im
 *             Banner als Kachel-Picker dargestellt. Beim Submit werden die
 *             Auswahlen als versteckte Inputs in die Produkt-Form geklont,
 *             sodass Shopify sie als Line-Item-Properties am Hauptartikel
 *             speichert. Property-Name auf Deutsch (analog Konfi):
 *             „Bonus-<Titel>" — erscheint im Warenkorb genauso.
 *
 *   Datenquelle: dieselbe Storefront API wie der Konfigurator. Der Token wird
 *   aus dem Konfigurator-Section-Wrapper auf derselben PDP gelesen (jede
 *   dollpark-PDP rendert die Konfi-Section, auch wenn versteckt).
 *
 *   Robustheits-Prinzip (CLAUDE.md §8): wenn irgendetwas an der Aktion
 *   unerwartet ist (Banner fehlt, Token fehlt, Storefront-Fetch scheitert,
 *   keine OVs für die Gruppe), darf das den normalen Kauf NIE blockieren.
 */
(function () {
  'use strict';

  // Modul-scoped Excludes-Set, befüllt in init(), gelesen in renderTiles().
  // Wird mit OptionValue-Handles aus dem Aktion-Metaobjekt befüllt — Pflege
  // im Admin via Feld `excludes_optionvalues` am manufacturer_promotion.
  let mppExcludedOvHandles = new Set();

  function init() {
    const banner = document.querySelector('.mpp-banner');
    if (!banner) return;

    const manufacturer = (banner.getAttribute('data-manufacturer') || '').trim();

    const giftRaw = banner.getAttribute('data-gift-variants') || '';
    const giftVariantIds = giftRaw
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .map(s => Number(s))
      .filter(n => Number.isFinite(n) && n > 0);

    // Excludes OptionValues: per Aktion gepflegte OV-Handles, die im Bonus-
    // Picker NICHT angeboten werden sollen (z.B. ROS MAX).
    const excludesRaw = banner.getAttribute('data-excludes-optionvalues') || '';
    mppExcludedOvHandles = new Set(
      excludesRaw.split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
    );

    // Geschenkartikel: Klick-Header zum Aufklappen wiren (zeigt Bild + Beschreibung).
    Array.from(banner.querySelectorAll('.mpp-gift')).forEach(wireSimpleToggle);

    // Bonus-Picker: Klick-Header zum Aufklappen wiren. Tiles werden LAZY
    // (erst beim Aufklappen) geladen — spart die PDP-Initialzeit.
    const bonusContainers = Array.from(banner.querySelectorAll('.mpp-bonus'));
    bonusContainers.forEach(c => wireBonusToggle(c, manufacturer));

    // Form-Submit hooken (auch wenn Bonus-Tiles noch leer sind — Form geht nicht weg)
    wireForms();

    function wireForms() {
      const forms = Array.from(document.querySelectorAll('form[action="/cart/add"], form[action$="/cart/add"]'));
      forms.forEach(form => {
        if (form.dataset.mppWired === '1') return;
        form.dataset.mppWired = '1';

        form.addEventListener('submit', function () {
          // 1) Bonus-Choices: angekreuzte Radios in die Form klonen
          const checked = banner.querySelectorAll('.mpp-bonus__radio:checked');
          checked.forEach(radio => {
            const existing = form.querySelector('input[name="' + CSS.escape(radio.name) + '"][data-mpp-bonus="1"]');
            if (existing) existing.remove();
            const clone = document.createElement('input');
            clone.type = 'hidden';
            clone.name = radio.name;
            clone.value = radio.value;
            clone.setAttribute('data-mpp-bonus', '1');
            form.appendChild(clone);
          });

          // 2) Geschenkartikel: nach dem normalen Submit nachladen
          if (giftVariantIds.length) {
            setTimeout(addGiftsToCart, 80);
          }
        }, true);
      });
    }

    function addGiftsToCart() {
      const items = giftVariantIds.map(id => ({ id: id, quantity: 1 }));
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).catch(err => {
        try { console.warn('[mpp] Geschenkartikel konnten nicht angehängt werden:', err); } catch (_) {}
      });
    }
  }

  // ===== Geschenkartikel: einfacher Toggle (kein Lazy-Load) =====

  function wireSimpleToggle(container) {
    const head = container.querySelector('.mpp-gift__head, .mpp-bonus__head');
    if (!head) return;
    head.addEventListener('click', function () {
      const expanded = container.classList.toggle('is-collapsed') === false;
      head.setAttribute('aria-expanded', String(expanded));
    });
  }

  // ===== Bonus-Picker: Aufklappen + Lazy-Load =====

  // Geteilter Cache pro Hersteller, damit beim Aufklappen der zweiten Gruppe
  // (und ab da jeder weiteren) keine erneute Storefront-Abfrage läuft.
  const ovCache = new Map(); // manufacturer -> Promise<Array<OV>>

  function wireBonusToggle(container, manufacturer) {
    const head = container.querySelector('.mpp-bonus__head');
    const body = container.querySelector('.mpp-bonus__body');
    if (!head || !body) return;

    head.addEventListener('click', function () {
      const expanded = container.classList.toggle('is-collapsed') === false;
      head.setAttribute('aria-expanded', String(expanded));
      body.hidden = !expanded;
      if (expanded && container.dataset.mppLoaded !== '1') {
        container.dataset.mppLoaded = '1';
        loadBonusTiles(container, manufacturer);
      }
    });
  }

  function loadBonusTiles(container, manufacturer) {
    const grid = container.querySelector('.mpp-bonus__grid');
    const groupKey = (container.getAttribute('data-bonus-group') || '').trim();
    const propertyName = (container.getAttribute('data-bonus-property') || '').trim();
    if (!grid || !groupKey) return;

    grid.innerHTML = '<p class="mpp-bonus__loading">Lade Auswahl…</p>';

    // Token + Shop-Domain aus dem Konfigurator-Wrapper auf derselben Seite.
    const cfg = document.querySelector('.product-configurator-api');
    if (!cfg) {
      grid.innerHTML = '<p class="mpp-bonus__empty">Konfigurator-Daten nicht erreichbar.</p>';
      return;
    }
    const token = (cfg.getAttribute('data-sf-token') || '').trim();
    const shopDomain = (cfg.getAttribute('data-shop-domain') || '').trim();
    if (!token || !shopDomain) {
      grid.innerHTML = '<p class="mpp-bonus__empty">Konfigurator-Token fehlt.</p>';
      return;
    }

    // SelectedState der Puppe für den Rules-Engine-Filter — Body, Material,
    // Hautfarbe, Kopf, Augenfarbe, Geschlecht. So filtern wir Bonus-Köpfe
    // analog zum Konfi (z.B. „excludes_any: body=108_l").
    const selectedState = buildSelectedState(cfg);

    if (!ovCache.has(manufacturer)) {
      ovCache.set(manufacturer, fetchOptionValuesForManufacturer(shopDomain, token, manufacturer));
    }

    ovCache.get(manufacturer)
      .then(allOVs => {
        const ovs = allOVs.filter(ov => {
          if ((ov.option_group || '').trim() !== groupKey) return false;
          return isOptionAllowedByRules(ov, selectedState);
        });
        renderTiles(container, ovs, propertyName);
      })
      .catch(err => {
        try { console.warn('[mpp] Bonus-Optionen konnten nicht geladen werden:', err); } catch (_) {}
        grid.innerHTML = '<p class="mpp-bonus__empty">Bonus-Auswahl gerade nicht verfügbar.</p>';
        // Cache löschen, damit ein Reload bei nächstem Aufklappen einen neuen Versuch macht
        ovCache.delete(manufacturer);
        container.dataset.mppLoaded = '';
      });
  }

  function fetchOptionValuesForManufacturer(shopDomain, token, manufacturer) {
    const all = [];
    const PAGE_SIZE = 250;

    function pageQuery(cursor) {
      const after = cursor ? `, after: "${cursor}"` : '';
      return `
        query {
          metaobjects(type: "optionvalue", first: ${PAGE_SIZE}${after}) {
            edges {
              node {
                handle
                fields {
                  key
                  value
                  reference {
                    ... on MediaImage { image { url } }
                    ... on GenericFile { url }
                    ... on ProductVariant { id }
                  }
                }
              }
            }
            pageInfo { hasNextPage endCursor }
          }
        }`;
    }

    function fetchPage(cursor) {
      return fetch('https://' + shopDomain + '/api/2026-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({ query: pageQuery(cursor) })
      }).then(r => r.json()).then(res => {
        const edges = (res.data && res.data.metaobjects && res.data.metaobjects.edges) || [];
        edges.forEach(e => {
          const fmap = { handle: e.node.handle || '' };
          (e.node.fields || []).forEach(f => {
            if (!f.key) return;
            if (f.key === 'image' && f.reference) {
              const ref = f.reference;
              fmap.image_url = (ref.image && ref.image.url) || ref.url || '';
            } else if (f.reference) {
              // Variant-Referenzen (addon_variant_*, body_variant) merken wir
              // als ID — wir brauchen nur „existiert ja/nein" für den Material-
              // Filter, kein Variant-Add-to-Cart auf der PDP-Direkt-Strecke.
              fmap[f.key] = f.reference.id || 'present';
            } else {
              fmap[f.key] = f.value;
            }
          });
          if ((fmap.manufacturer || '').trim() === manufacturer) {
            all.push(fmap);
          }
        });
        const pi = (res.data && res.data.metaobjects && res.data.metaobjects.pageInfo) || {};
        if (pi.hasNextPage) return fetchPage(pi.endCursor);
        return all;
      });
    }

    return fetchPage(null);
  }

  function renderTiles(container, ovs, propertyName) {
    const grid = container.querySelector('.mpp-bonus__grid');
    if (!grid) return;
    grid.innerHTML = '';

    // Sortierung: nach sort_order, dann label
    ovs.sort((a, b) => {
      const sa = Number(a.sort_order || 0);
      const sb = Number(b.sort_order || 0);
      if (sa !== sb) return sa - sb;
      return String(a.label || '').localeCompare(String(b.label || ''));
    });

    let added = 0;
    ovs.forEach(ov => {
      const label = (ov.label || ov.value_key || '').trim();
      const vk = (ov.value_key || '').trim();
      if (!label) return;
      // „Wie abgebildet"-Tile rauswerfen — bei Bonus ergibt das keinen Sinn
      // (der Kunde bekommt den abgebildeten Kopf/die Perücke schon als
      // Hauptauswahl). Match auf value_key, nicht label, weil das Label
      // lokalisiert sein kann ("Wie abgebildet" / "As Shown").
      if (vk === 'As Shown' || vk === 'as_shown' || label === 'Wie abgebildet') return;
      // Per-Aktion-Ausschluss: pflegt die Aktion bestimmte OVs in
      // excludes_optionvalues, blenden wir sie hier aus (z.B. ROS MAX).
      const ovHandle = String(ov.handle || '').toLowerCase();
      if (ovHandle && mppExcludedOvHandles.has(ovHandle)) return;

      const tile = document.createElement('label');
      tile.className = 'mpp-bonus__tile';

      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = propertyName;
      radio.value = label;
      radio.className = 'mpp-bonus__radio';
      tile.appendChild(radio);

      const imgUrl = (ov.image_url || '').trim();
      if (imgUrl) {
        const img = document.createElement('img');
        img.src = imgUrl;
        img.alt = label;
        img.loading = 'lazy';
        img.className = 'mpp-bonus__img';
        tile.appendChild(img);
      } else {
        const ph = document.createElement('span');
        ph.className = 'mpp-bonus__placeholder';
        tile.appendChild(ph);
      }

      const lbl = document.createElement('span');
      lbl.className = 'mpp-bonus__label';
      lbl.textContent = label;
      tile.appendChild(lbl);

      // Nach Auswahl: Sektion einklappen und Head als Summary umschreiben
      // ("Bonus-Kopf: Nr. 016 — ändern"). Re-Öffnen via Head-Klick bleibt
      // möglich (Toggle-Handler unverändert).
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        applyBonusSelection(container, label);
      });

      grid.appendChild(tile);
      added++;
    });

    if (added === 0) {
      const empty = document.createElement('p');
      empty.className = 'mpp-bonus__empty';
      empty.textContent = 'Keine Optionen für diese Bonus-Gruppe gefunden.';
      grid.appendChild(empty);
    }
  }

  // ===== Rules-Engine — portiert aus dem Konfi =====
  // Identische Semantik wie product-configurator-api.liquid: parseRulesSafe +
  // ruleNodeIsTrue + isOptionAllowedByRules. Unterstützt atomic { group,
  // value_key | value_key_not } und Kombinatoren requires_any / requires_all /
  // excludes_any / excludes_all / requires_not_all / requires_group_selected.
  // Der `expr`-Pfad wird übersprungen (selten genutzt, niemand würde erwarten
  // dass eine fehlende expr-Auswertung eine Bestellung blockiert — wir
  // erlauben dann großzügig).
  // Robustheits-Prinzip (CLAUDE.md §8): kaputtes/leeres rules-JSON → erlauben.
  function parseRulesSafe(rules) {
    if (!rules) return null;
    try { return typeof rules === 'string' ? JSON.parse(rules) : rules; }
    catch (e) { return null; }
  }

  // 3-Wege-Evaluator: true / false / null (= unbekannt — selectedState kennt
  // diese Group nicht). Wichtig, weil die PDP-Direkt-Strecke nur einen Teil
  // der Selections kennt (Body, Material, Hautfarbe, Kopf, Augenfarbe, Sex)
  // und z.B. hair_type nicht. Strikte Auswertung würde Wigs fälschlich
  // ausschließen, sobald sie hair_type=wig fordern.
  function ruleNodeIsTrue(node, sel) {
    if (!node || typeof node !== 'object') return true;
    if (node.expr) return true; // expr-Pfad nicht portiert → großzügig erlauben

    if (node.group) {
      if (!(node.group in sel)) return null; // nicht entscheidbar
      const current = String(sel[node.group] || '');
      if (Object.prototype.hasOwnProperty.call(node, 'value_key')) {
        return current.trim().toLowerCase() === String(node.value_key || '').trim().toLowerCase();
      }
      if (Object.prototype.hasOwnProperty.call(node, 'value_key_not')) {
        return current.trim().toLowerCase() !== String(node.value_key_not || '').trim().toLowerCase();
      }
      return !!current;
    }

    if (Array.isArray(node.requires_group_selected) && node.requires_group_selected.length) {
      const known = node.requires_group_selected.filter(g => g in sel);
      if (!known.length) return null;
      return known.every(g => !!sel[g]);
    }

    function evalKnown(arr) {
      return arr.map(n => ruleNodeIsTrue(n, sel)).filter(r => r !== null);
    }

    if (Array.isArray(node.requires_any) && node.requires_any.length) {
      const r = evalKnown(node.requires_any);
      if (!r.length) return null;
      return r.some(x => x === true);
    }
    if (Array.isArray(node.requires_all) && node.requires_all.length) {
      const r = evalKnown(node.requires_all);
      if (!r.length) return null;
      return r.every(x => x === true);
    }
    if (Array.isArray(node.excludes_any) && node.excludes_any.length) {
      const r = evalKnown(node.excludes_any);
      if (!r.length) return true; // keine bekannte Ausschluss-Bedingung → erlauben
      return !r.some(x => x === true);
    }
    if (Array.isArray(node.excludes_all) && node.excludes_all.length) {
      const r = evalKnown(node.excludes_all);
      if (!r.length) return true;
      return !r.every(x => x === true);
    }
    if (Array.isArray(node.requires_not_all) && node.requires_not_all.length) {
      const r = evalKnown(node.requires_not_all);
      if (!r.length) return null;
      return !r.every(x => x === true);
    }
    return true;
  }

  function isOptionAllowedByRules(ov, sel) {
    const rules = parseRulesSafe(ov && ov.rules);
    if (!rules) return true;
    const r = ruleNodeIsTrue(rules, sel);
    // Unbekannt (null) → konservativ erlauben statt blockieren.
    if (r === null) return true;
    return r === true;
  }

  // selectedState für die PDP zusammenbauen — Default-Werte des Produkts
  // (Body, Material, Hautfarbe, Kopf, Augenfarbe, Geschlecht). Stammen aus
  // den Produkt-Metafeldern, die im Konfi-Wrapper bereits ausgegeben sind.
  function buildSelectedState(cfg) {
    const sel = {};
    function add(group, val) {
      const v = (val || '').trim();
      if (v) sel[group] = v;
    }
    add('body', cfg.getAttribute('data-product-body-key'));
    add('material', (cfg.getAttribute('data-default-material') || '').toLowerCase());
    add('skin_color', cfg.getAttribute('data-default-skin-color'));
    add('eye_color', cfg.getAttribute('data-default-eye-color'));
    add('head', cfg.getAttribute('data-default-head'));
    add('sex', cfg.getAttribute('data-default-sex'));
    return sel;
  }

  function applyBonusSelection(container, label) {
    const title = (container.getAttribute('data-bonus-title') || 'Bonus').trim();
    const head = container.querySelector('.mpp-bonus__head');
    const headText = container.querySelector('.mpp-bonus__head-text');
    if (headText) {
      headText.innerHTML = '';
      const strong = document.createElement('strong');
      strong.textContent = 'Bonus-' + title + ':';
      headText.appendChild(strong);
      headText.appendChild(document.createTextNode(' ' + label + ' '));
      const em = document.createElement('em');
      em.className = 'mpp-bonus__head-change';
      em.textContent = '— ändern';
      headText.appendChild(em);
    }
    // Grünes Häkchen einmalig vor dem Head-Text — selbe Optik wie Geschenkartikel.
    if (head && !head.querySelector('.mpp-bonus__check')) {
      const check = document.createElement('span');
      check.className = 'mpp-bonus__check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';
      head.insertBefore(check, head.firstChild);
    }
    container.classList.add('is-collapsed');
    const body = container.querySelector('.mpp-bonus__body');
    if (head) head.setAttribute('aria-expanded', 'false');
    if (body) body.hidden = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();